import { getToken } from '../utils/getToken'

export default {
  getAll,
}

function handleSuccess(result) {
  if (!result.ok) throw new Error(result)
  return result.json()
}

function handleFailure(defaultErrorMessage, err) {
  throw new Error(defaultErrorMessage || err)
}

function getAll() {
  return fetch('/api/report-types', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve report types.', err))
}
